import { SignUp } from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Brand";

export default function SignUpPage() {
    return (
        <div className="min-h-screen bg-paper flex flex-col">
            <header className="px-5 py-4 sm:px-8 sm:py-6">
                <Link
                    to="/"
                    data-testid="signup-brand-link"
                    className="no-underline"
                >
                    <Wordmark height={26} />
                </Link>
            </header>
            <main className="flex-1 flex items-start sm:items-center justify-center px-4 pb-16">
                <div className="w-full max-w-md">
                    <div className="samoony-label mb-3 text-center">
                        Start here
                    </div>
                    <h1
                        className="samoony-hero text-center mb-6"
                        style={{ fontSize: "clamp(44px, 10vw, 64px)", fontStretch: "72%" }}
                    >
                        Get <span className="text-signal">named</span>.
                    </h1>
                    <div data-testid="clerk-signup">
                        <SignUp
                            routing="path"
                            path="/sign-up"
                            signInUrl="/sign-in"
                            forceRedirectUrl="/onboarding"
                        />
                    </div>
                </div>
            </main>
        </div>
    );
}
